import type { MfaOption, MfaType } from "@repo/ui";

import { BaseController } from "./baseController";

export interface LoginResultMVC {
	success: boolean;
	message: string;
	returnUrl: string;
	mustChangePassword: boolean;
	changePasswordUrl: string;
	mfaRequired: boolean;
	mfaOptions: MfaType[];
}

interface ChangePasswordResultMVC {
	success: boolean;
	message: string;
}

interface AuthSettings {
	tlpLogo: string;
	backgroundImage: string;
	companyLogo: string;
	canStoreMachine: boolean;
}

const controller = "/MVC/Account";

export class AccountController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);
	public static getSettings(username?: string) {
		return AccountController.Get<AuthSettings>("GetSettings", { username });
	}

	public static login(username: string, password: string) {
		return AccountController.Post<LoginResultMVC>("Login", undefined, {
			username,
			password,
			timezoneOffset: new Date().getTimezoneOffset(),
		});
	}

	public static logout() {
		return AccountController.Get<LoginResultMVC>("Logout");
	}

	public static forgotPassword(username: string) {
		return AccountController.Post<LoginResultMVC>("ForgotPasswordDyn", undefined, {
			login: username,
		});
	}

	// Initial login with default password required, user is required to change password
	public static resetPassword(username: string, newPassword: string) {
		return AccountController.Post<LoginResultMVC>("ResetPasswordDyn", undefined, {
			username,
			newPassword,
		});
	}

	public static changePassword(oldPassword: string, newPassword: string) {
		return AccountController.Post<ChangePasswordResultMVC>("ChangePassword", undefined, {
			oldPassword,
			newPassword,
		});
	}

	public static oneTimePassword(username: string, otp: string, canStoreMachine: boolean) {
		return AccountController.Post<LoginResultMVC>("OneTimePassword", undefined, {
			username,
			otp,
			timezoneOffset: new Date().getTimezoneOffset(),
			canStoreMachine,
		});
	}

	public static getMfaTypes(username: string) {
		return AccountController.Get<MfaType[]>("GetMfaTypes", { username });
	}

	public static requestMfaCode(username: string, type: MfaOption) {
		return AccountController.Post<LoginResultMVC>("RequestMfaCode", undefined, {
			username,
			type,
		});
	}
}
